import {
  getHostBufferAll,
  addHostBufferRequest,
  delHostBufferRequest,
  reloadTreePathRequest,
  submitDeliveryRequest
} from '../api/api'

const state = {
  user: null,
  isLogin: false
}

const getters = {}

const mutations = {
  SET_DOING_LOGIN (state, isLogin) {
    state.isLogin = isLogin
  },
  SET_LOGIN_USER (state, user) {
    state.user = user
  },
  SET_LOGIN_TOKEN (state, token) {
    if (token) {
      sessionStorage.setItem('token', token)
    } else {
      sessionStorage.removeItem('token')
    }
  }
}

const actions = {
  // get url 拼接
  async getUrl ({commit}, params) {
    let rangeArr = []
    let param = ''
    if (params && typeof params === 'object') {
      if (rangeArr.length === 0) {
        rangeArr.push('?')
      }
      for (const i in params) {
        if (params.hasOwnProperty(i)) {
          if (params[i] !== '') {
            rangeArr.push(i)
            rangeArr.push('=')
            rangeArr.push(params[i])
            rangeArr.push('&')
          }
        }
      }
      param = rangeArr.join('').replace(/&$/, '')
    }
    return param
  },
  // 加载主机
  async reloadHostBufferMethod ({dispatch, commit}, params) {
    return dispatch('getUrl', params).then(response => {
      return getHostBufferAll(response).then(rep => rep)
    })
  },
  // 添加主机
  async createHostBufferMethod ({dispatch, commit}, params) {
    return addHostBufferRequest(params).then(response => response)
  },
  // 删除主机
  async deleteHostBufferMethod ({dispatch, commit}, params) {
    return delHostBufferRequest(params).then(response => response)
  },
  // 加载交付产品线
  async reloadTreePathMethod ({dispatch, commit}, params) {
    return reloadTreePathRequest(params).then(response => response)
  },
  // 提交，交付
  async submitDeliveryMethod ({dispatch, commit}, params) {
    return submitDeliveryRequest(params).then(response => response)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/host.js